module.exports = __webpack_public_path__ + "static/img/ic_gy_d_f@2x.7a240e39.png";